<template>
  <div class="button-row">
    <MyButton
      class="btn"
      v-for="(button, index) in buttons"
      :key="index"
      :label="button.label"
      :route="button.route"
      :link="button.link"
      :type="button.type"
      :size="button.size"
      :icon="button.icon"
      :iconRight="button.iconRight"
    ></MyButton>
  </div>
</template>

<script>
import MyButton from './Button/Button.vue';

export default {
  components: {
    MyButton,
  },
  props: {
    buttons: {
      type: Array,
      required: true,
    },
  },
  // data() {
  //   return {
  //     buttons: [
  //       {
  //         label: "Button 1",
  //         route: "/button1",
  //         type: "solid",
  //         size: "large",
  //       },
  //       {
  //         label: "Button 2",
  //         route: "/button2",
  //         type: "outline",
  //         size: "small",
  //       },
  //       // Add more buttons as needed
  //     ],
  //   };
  // },
};
</script>

<style lang="scss" scoped>
.button-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  // background-color: red;
  flex-wrap: wrap;

  /* Stacked on mobile, so each button fills its row. */
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;

    :deep(#btn) {
      display: block;
    }

    :deep(.custom-btn) {
      inline-size: 100%;
    }
  }
  @media only screen and (min-width: 768px) {
    // background-color: blue;
    // flex-direction: row;
  }
  @media only screen and (min-width: 1201px) {
    // background-color: yellow;
  }
}
// .btn {
// }
</style>
